import { CardAffinity, CardType } from '@mythos/game/CardTypes';
import { Phase } from '@mythos/game/Phases';
import { Resource, Token } from '@mythos/game/Resources';
import invariant from 'invariant';
import React from 'react';

enum Symbols {
  ACQUIRE_TOKEN_WAR = 'acquire_token_war',
  ARROW_COLLAPSE = 'arrow_collapse',
  ARROW_EXPAND = 'arrow_expand',
  BASE_GOLD = 'base_gold',
  BASE_MILITARY = 'base_military',
  CARD_BACK = 'card_back',
  CARD_AFFINITY_ZEONA = 'card_affinity_zeona',
  CARD_AFFINITY_DERION = 'card_affinity_derion',
  CARD_AFFINITY_TYROS = 'card_affinity_tyros',
  CARD_AFFINITY_BASIC = 'card_affinity_basic',
  CARD_AFFINITY_LEADER = 'card_affinity_leader',

  CARD_AFFINITY_DERION_PROPHECY1 = 'card_affinity_derion_prophecy1',
  CARD_AFFINITY_TYROS_PROPHECY1 = 'card_affinity_tyros_prophecy1',
  CARD_AFFINITY_ZEONA_PROPHECY1 = 'card_affinity_zeona_prophecy1',

  CARD_TYPE_BUILDING_PROPHECY1 = 'card_type_building_prophecy1',
  CARD_TYPE_EVENT_PROPHECY1 = 'card_type_event_prophecy1',
  CARD_TYPE_UNIT_PROPHECY1 = 'card_type_unit_prophecy1',

  CARD_SET = 'card_type_set',
  CARD_TYPE_BUILDING = 'card_type_building',
  CARD_TYPE_UNIT = 'card_type_unit',
  CARD_TYPE_EVENT = 'card_type_event',
  EFFECT_PRODUCTION = 'effect_production',
  FAVOR = 'favor',
  FAVOR_T1 = 'favor_t1',
  FAVOR_T2 = 'favor_t2',
  FAVOR_T3 = 'favor_t3',
  FAVOR_T4 = 'favor_t4',
  GOLD = 'gold',
  M3_ACQUIRE = 'm3_acquire',
  M3_ACQUIRE_TRIBUTE = 'm3_acquire_tribute',
  M3_DRAFT_TYROS = 'm3_draft_tyros',
  M3_DRAFT_DERION = 'm3_draft_derion',
  M3_DRAFT_ZEONA = 'm3_draft_zeona',
  M3_DRAFT = 'm3_draft',
  MILITARY = 'military',
  MILITARY_WHITE_BORDER = 'military_white_border',
  PLANNING = 'planning',
  RESOLUTION = 'resolution',
  TOKEN_TRIBUTE = 'token_tribute',
  TOKEN_WAR = 'token_war',
  UPGRADE = 'upgrade',
  EOG = 'eog',
  OBTAIN = 'obtain',
}
export default Symbols;

import SymbolAcquireTokenWar from '../assets/symbols/acquire_token_clash.svg';
import SymbolArrowCollapse from '../assets/symbols/arrow_collapse.svg';
import SymbolArrowExpand from '../assets/symbols/arrow_expand.svg';
import SymbolBaseGold from '../assets/symbols/base_gold.svg';
import SymbolBaseMilitary from '../assets/symbols/base_military.svg';
import SymbolCardAffinityDerion from '../assets/symbols/card_affinity_derion.svg';
import SymbolCardAffinityDerionProphecy1 from '../assets/symbols/card_affinity_derion_prophecy1.svg';
import SymbolCardAffinityTyros from '../assets/symbols/card_affinity_tyros.svg';
import SymbolCardAffinityTyrosProphecy1 from '../assets/symbols/card_affinity_tyros_prophecy1.svg';
import SymbolCardAffinityZeona from '../assets/symbols/card_affinity_zeona.svg';
import SymbolCardAffinityZeonaProphecy1 from '../assets/symbols/card_affinity_zeona_prophecy1.svg';
import SymbolCardBack from '../assets/symbols/card_back.svg';
import SymbolCardSet from '../assets/symbols/card_set.svg';
import SymbolCardSubtypeBuilding from '../assets/symbols/card_subtype_building.svg';
import SymbolCardSubtypeEvent from '../assets/symbols/card_subtype_event.svg';
import SymbolCardSubtypeUnit from '../assets/symbols/card_subtype_unit.svg';
import SymbolCardTypeBasic from '../assets/symbols/card_type_basic.svg';
import SymbolCardTypeBuildingProphecy1 from '../assets/symbols/card_type_building_prophecy1.svg';
import SymbolCardTypeEventProphecy1 from '../assets/symbols/card_type_event_prophecy1.svg';
import SymbolCardTypeLeader from '../assets/symbols/card_type_leader.svg';
import SymbolCardTypeUnitProphecy1 from '../assets/symbols/card_type_unit_prophecy1.svg';
import SymbolEffectProduction from '../assets/symbols/effect_production.svg';
import SymbolEOG from '../assets/symbols/eog.svg';
import SymbolFavor from '../assets/symbols/favor.svg';
import SymbolFavorT2 from '../assets/symbols/favor_t2.svg';
import SymbolFavorT3 from '../assets/symbols/favor_t3.svg';
import SymbolFavorT4 from '../assets/symbols/favor_t4.svg';
import SymbolGold from '../assets/symbols/gold.svg';
import SymbolM3Acquire from '../assets/symbols/m3_acquire.svg';
import SymbolM3AcquireTribute from '../assets/symbols/m3_acquire_tribute.svg';
import SymbolM3Draft from '../assets/symbols/m3_draft.svg';
import SymbolM3DraftConflict from '../assets/symbols/m3_draft_conflict.svg';
import SymbolM3DraftPrayer from '../assets/symbols/m3_draft_prayer.svg';
import SymbolM3DraftResource from '../assets/symbols/m3_draft_resource.svg';
import SymbolMilitary from '../assets/symbols/military.svg';
import SymbolMilitaryWhiteBorder from '../assets/symbols/military_white_border.svg';
import SymbolObtain from '../assets/symbols/obtain.svg';
import SymbolPlanning from '../assets/symbols/planning.svg';
import SymbolResolution from '../assets/symbols/resolution.svg';
import SymbolTokenWar from '../assets/symbols/token_clash.svg';
import SymbolTokenTribute from '../assets/symbols/token_tribute.svg';
import SymbolUpgrade from '../assets/symbols/upgrade.svg';

export const SYMBOL_TO_IMAGE: Record<Symbols, string> = {
  [Symbols.ARROW_COLLAPSE]: SymbolArrowCollapse,
  [Symbols.ARROW_EXPAND]: SymbolArrowExpand,
  [Symbols.BASE_GOLD]: SymbolBaseGold,
  [Symbols.BASE_MILITARY]: SymbolBaseMilitary,
  [Symbols.CARD_BACK]: SymbolCardBack,
  [Symbols.CARD_TYPE_BUILDING]: SymbolCardSubtypeBuilding,
  [Symbols.CARD_TYPE_UNIT]: SymbolCardSubtypeUnit,
  [Symbols.CARD_TYPE_EVENT]: SymbolCardSubtypeEvent,
  [Symbols.CARD_AFFINITY_ZEONA]: SymbolCardAffinityZeona,
  [Symbols.CARD_AFFINITY_DERION]: SymbolCardAffinityDerion,
  [Symbols.CARD_AFFINITY_TYROS]: SymbolCardAffinityTyros,
  [Symbols.CARD_AFFINITY_BASIC]: SymbolCardTypeBasic,
  [Symbols.CARD_AFFINITY_LEADER]: SymbolCardTypeLeader,
  [Symbols.CARD_AFFINITY_DERION_PROPHECY1]: SymbolCardAffinityDerionProphecy1,
  [Symbols.CARD_AFFINITY_TYROS_PROPHECY1]: SymbolCardAffinityTyrosProphecy1,
  [Symbols.CARD_AFFINITY_ZEONA_PROPHECY1]: SymbolCardAffinityZeonaProphecy1,
  [Symbols.CARD_TYPE_BUILDING_PROPHECY1]: SymbolCardTypeBuildingProphecy1,
  [Symbols.CARD_TYPE_EVENT_PROPHECY1]: SymbolCardTypeEventProphecy1,
  [Symbols.CARD_TYPE_UNIT_PROPHECY1]: SymbolCardTypeUnitProphecy1,
  [Symbols.CARD_SET]: SymbolCardSet,
  [Symbols.EFFECT_PRODUCTION]: SymbolEffectProduction,
  [Symbols.FAVOR]: SymbolFavor,
  [Symbols.FAVOR_T1]: SymbolFavor,
  [Symbols.FAVOR_T2]: SymbolFavorT2,
  [Symbols.FAVOR_T3]: SymbolFavorT3,
  [Symbols.FAVOR_T4]: SymbolFavorT4,
  [Symbols.GOLD]: SymbolGold,
  [Symbols.TOKEN_TRIBUTE]: SymbolTokenTribute,
  [Symbols.M3_ACQUIRE]: SymbolM3Acquire,
  [Symbols.M3_ACQUIRE_TRIBUTE]: SymbolM3AcquireTribute,
  [Symbols.M3_DRAFT_TYROS]: SymbolM3DraftConflict,
  [Symbols.M3_DRAFT_DERION]: SymbolM3DraftResource,
  [Symbols.M3_DRAFT_ZEONA]: SymbolM3DraftPrayer,
  [Symbols.M3_DRAFT]: SymbolM3Draft,
  [Symbols.MILITARY]: SymbolMilitary,
  [Symbols.MILITARY_WHITE_BORDER]: SymbolMilitaryWhiteBorder,
  [Symbols.PLANNING]: SymbolPlanning,
  [Symbols.RESOLUTION]: SymbolResolution,
  [Symbols.TOKEN_WAR]: SymbolTokenWar,
  [Symbols.ACQUIRE_TOKEN_WAR]: SymbolAcquireTokenWar,
  [Symbols.UPGRADE]: SymbolUpgrade,
  [Symbols.EOG]: SymbolEOG,
  [Symbols.OBTAIN]: SymbolObtain,
};

export function SymbolView(props: {
  symbol: Symbols;
  style?: React.CSSProperties;
  className?: string;
  title?: string;
}): React.ReactElement {
  invariant(
    SYMBOL_TO_IMAGE[props.symbol],
    'invalid symbol: %s %s %s',
    props.symbol,
    props.className,
    props.title,
  );
  return (
    <img
      src={`${SYMBOL_TO_IMAGE[props.symbol]}`}
      className={props.className}
      style={props.style}
      title={props.title}
    />
  );
}

export const CardAffinityToSymbol: Record<CardAffinity, Symbols> = {
  [CardAffinity.Basic]: Symbols.CARD_AFFINITY_BASIC,
  [CardAffinity.Derion]: Symbols.CARD_AFFINITY_DERION,
  [CardAffinity.Tyros]: Symbols.CARD_AFFINITY_TYROS,
  [CardAffinity.Zeona]: Symbols.CARD_AFFINITY_ZEONA,
  [CardAffinity.Leader]: Symbols.CARD_AFFINITY_LEADER,
  [CardAffinity.None]: Symbols.CARD_AFFINITY_BASIC,
};
export const CardTypeToSymbol: Record<CardType, Symbols> = {
  [CardType.Unit]: Symbols.CARD_TYPE_UNIT,
  [CardType.Building]: Symbols.CARD_TYPE_BUILDING,
  [CardType.Event]: Symbols.CARD_TYPE_EVENT,
};

export const ResourceToSymbol: Record<Resource, Symbols> = {
  gold: Symbols.GOLD,
  military: Symbols.MILITARY,
  favor: Symbols.FAVOR,
  warTokens: Symbols.TOKEN_WAR,
  tributeTokens: Symbols.TOKEN_TRIBUTE,
};

export const BaseResourceToSymbol: Record<Resource, Symbols | null> = {
  gold: Symbols.BASE_GOLD,
  military: Symbols.BASE_MILITARY,
  favor: null,
  warTokens: null,
  tributeTokens: null,
};

export const PhaseToSymbol: Record<Phase, Symbols> = {
  [Phase.SETUP]: Symbols.PLANNING,
  [Phase.PLANNING]: Symbols.PLANNING,
  [Phase.RESOLUTION]: Symbols.RESOLUTION,
  [Phase.TRIBUTE]: Symbols.RESOLUTION,
  [Phase.WAR]: Symbols.PLANNING,
  [Phase.PRODUCTION]: Symbols.PLANNING,
};

export const TokenToSymbol: Record<Token, Symbols> = {
  [Token.War]: Symbols.TOKEN_WAR,
  [Token.Tribute]: Symbols.TOKEN_TRIBUTE,
};
